import React from 'react';

export const CreditsElement = function FromElement({ element, handlerChangeOption }) {
  const handleInputChange = (e) => {
    handlerChangeOption(!!e.target.value, 'filledByCreator', element.id);
    handlerChangeOption(e.target.value, 'valueInput', element.id);
  };

  return (
    <>
      <label htmlFor={element.id} className="form-label">
        {element.options.label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
      </label>
      <input
        name={element.options.name}
        id={element.id}
        value={element.options.valueInput}
        type="number"
        min={element.options.min}
        max={element.options.max}
        // Input Size already sets the field's width (50 / 75 / 100%), so the
        // input fills the field like the other inputs do, rather than being
        // shrunk by the size a second time — as the printed PDF already draws it.
        style={{ width: '100%' }}
        className={`form-control form-control-${element.options.size}`}
        onChange={handleInputChange}
      />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
